import { useState } from "react";
import { toast } from "react-toastify";
import { ReactComponent as CopyIcon } from "../../assets/img/copyicon.svg";
import { ReactComponent as TableCopyIcon } from "../../assets/img/tablecopyicon.svg";
import { ReactComponent as CheckIcon } from "../../assets/img/smallCheckIcon.svg";

interface CopyTextToClipboardType {
  textToCopy: string;
  isForTable?: boolean;
}

const CopyTextToClipboard = ({
  textToCopy,
  isForTable = true,
}: CopyTextToClipboardType) => {
  const [isCopied, setIsCopied] = useState(false);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2500);
    } catch (err) {
      toast.error("Failed to copy text!");
    }
  };
  return (
    <p
      onClick={handleCopy}
      className="w-fit flex items-center gap-3.5 cursor-pointer text-foreground font-sans font-medium hover:bg-[#e8e8e8] rounded-sm">
      {textToCopy}
      {isCopied ? (
        <span
          className={`flex ${
            !isForTable ? "h-[20px] w-[18px]" : "h-[12px] w-[12px]"
          } items-center justify-center`}>
          <CheckIcon />
        </span>
      ) : isForTable ? (
        <TableCopyIcon />
      ) : (
        <CopyIcon />
      )}
    </p>
  );
};

export default CopyTextToClipboard;
